import React from 'react'
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const statePark = "/img/nationalForest.jpeg";

const PlacesNationalForest = () => {
    const parks = [
        {
            "NAME": "Wasatch National Forest",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "11925 N Horizon Dr, Highland, UT 84003, United States",
            "Phone No:": "801-466-6411",
            "Website": "https://www.fs.usda.gov/uwcnf",
            "Established on": "4 March 1907"
        },
        {
            "NAME": "Ashley National Forest",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "355 N Vernal Ave, Vernal, UT 84078, United States",
            "Phone No:": "435-789-1181",
            "Website": "https://www.fs.usda.gov/ashley",
            "Established on": "1 July 1908"
        },
        {
            "NAME": "Uinta National Forest",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "Springville, UT 84663, United States",
            "Phone No:": "(801) 342-5100",
            "Website": "https://www.fs.usda.gov/uwcnf",
            "Established on": "2 February 1897"
        },
        {
            "NAME": "Manti-LaSal National Forest",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "599 W Price River Dr Price, UT 84501",
            "Phone No:": "(435) 636-3561",
            "Website": "https://www.fs.usda.gov/mantilasal",
            "Established on": "August 28, 1950"
        },
        {
            "NAME": "Fishlake National Forest",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "115 E 900 N, Sevier, UT 84766, United States",
            "Phone No:": "435-896-9233",
            "Website": "https://www.fs.usda.gov/main/fishlake/home",
            "Established on": "1 July 1908"
        },
        {
            "NAME": "Dixie National Forest",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "820 N Main St, Cedar City, UT 84721, United States",
            "Phone No:": "435-865-3700",
            "Website": "https://www.fs.usda.gov/dixie",
            "Established on": "25 September 1905"
        }
    ];

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{ imageName: "nationalForest.webp", title: "National Forests" }}
            />


            {/* <div className="overflow-x-auto w-full mb-[3rem]">
                <div
                    className=" bg-[#d2eaff] flex flex-col items-center justify-center"
                    aria-label="Utah aquatic scenery"
                    style={{
                        backgroundImage: `url(${statePark})`, // Replace with your image path
                        backgroundSize: "cover", // Ensures the image covers the entire container
                        backgroundPosition: "center", // Centers the image
                        backgroundRepeat: "no-repeat", // Prevents the image from repeating
                        width: "100%", // Ensures the container takes full width of the screen
                        height: "45vh", // Makes the container span the full height of the viewport
                    }}
                >
                    <h2
                        className="text-white text-center px-4 text-5xl sm:text-6xl md:text-6xl lg:text-7xl mt-7"
                        style={{
                            color: "white",
                            textShadow: "2px 2px 6px rgba(0, 0, 0, 0.7)", // Makes the text stand out
                            lineHeight: "1.2", // Adjusts line spacing
                        }}
                    >
                        National Forests
                    </h2>
                    <div className="mt-2 font-bold text-2xl" style={{ color: "#fff" }}>
                    </div>
                    <span
                        className="text-center px-4 text-2xl sm:text-2xl md:text-3xl lg:text-4xl mt-4"
                        style={{
                            color: "#fff",
                            fontFamily: "SignPainter", // Use the SignPainter font
                            textShadow: "1px 1px 4px rgba(0, 0, 0, 0.6)", // Adds subtle shadow
                            lineHeight: "1.5", // Adjusts line spacing
                        }}
                    >
                        Explore Utah By The Numbers
                    </span>
                </div>
            </div> */}

            {/* Main Content */}
            <div className=" mx-auto  py-12 w-full">
                {/* Intro Section */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
                        Utah's National Forests
                    </h1>
                    <p className="text-xl text-blue-700">
                        Explore the breathtaking wilderness of Utah's protected forests
                    </p>
                </div>

                {/* Stats Cards - Responsive Grid */}
                {/* <div className='flex items-center justify-center'>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12 max-w-7xl">
                        <div className="bg-white rounded-xl shadow-md p-6 border border-blue-100 hover:shadow-lg transition-shadow">
                            <h3 className="text-lg font-semibold text-blue-800 mb-2">Total Forests</h3>
                            <p className="text-3xl font-bold text-blue-600">{ parks.length }</p>
                        </div>
                        <div className="bg-white rounded-xl shadow-md p-6 border border-blue-100 hover:shadow-lg transition-shadow">
                            <h3 className="text-lg font-semibold text-blue-800 mb-2">Total Area</h3>
                            <p className="text-3xl font-bold text-blue-600">9.2M</p>
                            <p className="text-sm text-gray-600">acres</p>
                        </div>
                        <div className="bg-white rounded-xl shadow-md p-6 border border-blue-100 hover:shadow-lg transition-shadow">
                            <h3 className="text-lg font-semibold text-blue-800 mb-2">Visitors (2023)</h3>
                            <p className="text-3xl font-bold text-blue-600">4.2M</p>
                        </div>
                        <div className="bg-white rounded-xl shadow-md p-6 border border-blue-100 hover:shadow-lg transition-shadow">
                            <h3 className="text-lg font-semibold text-blue-800 mb-2">Established</h3>
                            <p className="text-3xl font-bold text-blue-600">1906</p>
                            <p className="text-sm text-gray-600">(oldest)</p>
                        </div>
                    </div>
                </div> */}

                {/* Parks Table */}
                <div className='flex items-center justify-center'>
                    <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
                        <div className="overflow-x-auto">
                            <table className="min-w-full">
                                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                                    <tr>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Name
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Land Administrator
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Contact
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Website
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {parks.map((park, index) => (
                                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park.NAME}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["LAND ADMINISTRATOR"]}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["Phone No:"]}</div>
                                                <div className="text-sm text-center font-bold text-blue-900">{park.Address}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <a
                                                    href={park.Website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                                                >
                                                    Visit Website
                                                </a>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Additional Content Section */}
                {/* <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-blue-900 mb-4">About Utah's National Forests</h2>
                            <p className="text-gray-700 mb-4">
                                Utah's national forests offer millions of acres of breathtaking landscapes,
                                from high mountain peaks to red rock canyons. These protected lands provide
                                recreation opportunities, wildlife habitat, and vital watershed protection.
                            </p>
                            <Link
                                to="/learn-more"
                                className="inline-flex items-center text-blue-600 hover:text-blue-800"
                            >
                                Learn more about conservation efforts
                                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                    <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200">
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-blue-900 mb-4">Visitor Information</h2>
                            <ul className="space-y-3 text-gray-700">
                                <li className="flex items-start">
                                    <svg className="w-5 h-5 text-blue-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span>Check for seasonal closures before visiting</span>
                                </li>
                                <li className="flex items-start">
                                    <svg className="w-5 h-5 text-blue-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span>Purchase passes online or at visitor centers</span>
                                </li>
                                <li className="flex items-start">
                                    <svg className="w-5 h-5 text-blue-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span>Practice Leave No Trace principles</span>
                                </li>
                            </ul>
                            <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                                Download Visitor Guide
                            </button>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default PlacesNationalForest
